export const TOGGLE_THEME_MODE = "TOGGLE_THEME_MODE";
export const toggleThemeMode = () => ({ type: TOGGLE_THEME_MODE });
